
import { makeStyles } from "@material-ui/core/styles";
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(( ) => ({
  root: {
    "--create-padding-0": `0px`,
    "--create-padding-1": `${CELL_WIDTHS.EXPAND.DEPTH_1 - 14}px`,
    "--create-padding-2": `${CELL_WIDTHS.EXPAND.DEPTH_2 - 14}px`,
    "--create-padding-3": `${CELL_WIDTHS.EXPAND.DEPTH_3 - 14}px`,
  }
}));

export default useStyle;